import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import Popover from '@mui/material/Popover';
import Box from "@mui/material/Box";
import { IconButton } from '@mui/material';

const CustomPopoverContext = React.createContext();
export const useCustomPopover = () => React.useContext(CustomPopoverContext);

function CustomPopover({
  buttonTrigger,
  iconTrigger,
  popoverContent,
  anchorOrigin,
  transformOrigin,
  onButtonClick = '',
  style,
  buttonStyle,
  setShowFilterSort = () => {},
  setShowEditFilter = () => {},
  showEditFilter = false,
  onOpenChange = () => {},
  inline = true
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const buttonRef = useRef(null);

  // If showEditFilter becomes true, open the popover below the button
  useEffect(() => {
    if (showEditFilter && buttonRef.current) {
      setAnchorEl(buttonRef.current);
    }
  }, [showEditFilter]);

  const handleClick = (event) => {
    if (onButtonClick !== '') {
      onButtonClick();
    }
    // Always set anchor to the button/icon that was clicked
    setAnchorEl(event.currentTarget);
    onOpenChange(true);
  };

  const handleClose = () => {
    setShowFilterSort(false);
    setShowEditFilter(false);
    setAnchorEl(null);
    onOpenChange(false);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <CustomPopoverContext.Provider value={{ handleClose, open }}>
      {buttonTrigger ? (
        <div
          aria-describedby={id}
          onClick={handleClick}
          ref={buttonRef}
          style={inline ? { display: 'inline-block' } : { display: 'block' }}
        >
          {buttonTrigger}
        </div>
      ) : null}
      {iconTrigger ? (
        <IconButton
          size="small"
          aria-describedby={id}
          aria-label="popover-trigger"
          onClick={handleClick}
          sx={buttonStyle}
          ref={buttonRef}
        >
          {iconTrigger}
        </IconButton>
      ) : null}
      <Popover
        style={style}
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin }
        transformOrigin={transformOrigin}
        PaperProps={{ style: style }}
      >
        <div>{popoverContent}</div>
      </Popover>
    </CustomPopoverContext.Provider>
  );
}

CustomPopover.propTypes = {
  // buttonLabel: PropTypes.string.isRequired,
  popoverContent: PropTypes.node.isRequired,
  anchorOrigin: PropTypes.shape({
    vertical: PropTypes.oneOf(['top', 'bottom', 'center', 'stretch']),
    horizontal: PropTypes.oneOf(['left', 'center', 'right']),
  }),
  inline: PropTypes.bool,
};

CustomPopover.defaultProps = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  inline: true,
};

export default CustomPopover;
